module.exports = __webpack_public_path__ + "img/Checkbox-Off_16px_Icon_light.0e0b8232.svg";